"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CognitoService = void 0;
let pendingMfaUser = null;
exports.CognitoService = {
    setPendingMfaUser(user) {
        pendingMfaUser = user;
    },
    getPendingMfaUser() {
        return pendingMfaUser;
    },
};
